export const getHeadingAndSubheadingForTotalWords = (
  characterCount: number
) => {
  if (characterCount <= 5000) {
    return {
      heading: "You're just getting started",
      subheading: "It's like penning a thoughtful magazine column!",
    };
  } else if (characterCount <= 10000) {
    return {
      heading: "You've got some creative sparks",
      subheading: "That's like writing a feature article in Time Magazine!",
    };
  } else if (characterCount <= 25000) {
    return {
      heading: "You're a rising storyteller",
      subheading: "That's like writing a full series of blog posts!",
    };
  } else if (characterCount <= 50000) {
    return {
      heading: "You're a novice novelist",
      subheading: "You're nearing the length of The Great Gatsby!",
    };
  } else if (characterCount <= 100000) {
    return {
      heading: "You're an avid writer",
      subheading:
        "You've written nearly as much as Harry Potter & the Sorcerer's Stone!",
    };
  } else if (characterCount <= 200000) {
    return {
      heading: "You're a full-blown novelist",
      subheading: "Your words match the span of Pride and Prejudice!",
    };
  } else if (characterCount <= 300000) {
    return {
      heading: "You've written A LOT this year",
      subheading: "You've penned enough to rival War and Peace!",
    };
  } else {
    return {
      heading: "You've written A LOT this year",
      subheading:
        "Like writing the entire Lord of the Rings trilogy and then some!",
    };
  }
};

export const getHeadingAndSubheadingForTotalImpressions = (
  impressions: number
) => {
  if (impressions < 10000) {
    return {
      heading: "You've reached",
      subheading: "That's like filling a small stadium!",
    };
  } else if (impressions < 50000) {
    return {
      heading: "Your voice echoed to",
      subheading: "Almost the population of a small town!",
    };
  } else if (impressions < 100000) {
    return {
      heading: "Your content touched",
      subheading: "Comparable to a large stadium's capacity!",
    };
  } else if (impressions < 200000) {
    return {
      heading: "Your thoughts impacted",
      subheading: "You've outshone many viral videos!",
    };
  } else if (impressions < 600000) {
    return {
      heading: "You influenced",
      subheading: "That's like reaching the entire city of Luxembourg!",
    };
  } else if (impressions < 1700000) {
    return {
      heading: "Your reach extended to",
      subheading: "Matching the population of Vienna!",
    };
  } else if (impressions < 2500000) {
    return {
      heading: "Your thoughts impacted",
      subheading: "You're competing with small countries now!",
    };
  } else if (impressions < 3500000) {
    return {
      heading: "Your ideas reached",
      subheading: "Surpassing the population of Iceland, multiple times!",
    };
  } else if (impressions < 4500000) {
    return {
      heading: "You influenced",
      subheading: "That's more than the population of Hong Kong!",
    };
  } else if (impressions < 10000000) {
    return {
      heading: "Your content touched",
      subheading: "Rivaling the audience of national TV!",
    };
  } else if (impressions < 20000000) {
    return {
      heading: "Your thoughts impacted",
      subheading: "Twice as many as the best-selling books' readers!",
    };
  } else {
    return {
      heading: "Your content touched",
      subheading: "A voice as loud as big media networks!",
    };
  }
};

export const getStreakHeading = (streakDays: number) => {
  if (streakDays <= 15) {
    return "Your streak's taking shape, nice one!";
  } else if (streakDays <= 30) {
    return "You've kicked off your streak, great start!";
  } else if (streakDays <= 50) {
    return "Your streak game is strongggg!";
  } else if (streakDays <= 100) {
    return "Woah, you're on a rolllll!";
  } else {
    return "You've made the looooongest streak";
  }
};
